import { render, staticRenderFns } from "./null_study_tabs.vue?vue&type=template&id=f4e0b8d8"
import script from "./null_study_tabs.vue?vue&type=script&lang=js"
export * from "./null_study_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports